import React from 'react';

import { Skeleton } from '@epoch-ui/components/Skeleton/skeleton';

export const TemplateLoadingSkeleton: React.FC = () => {
  return (
    <div className="tw-space-y-4">
      {Array.from({ length: 3 }).map((_, i) => (
        <div
          key={i}
          className={`tw-flex tw-w-full tw-items-center tw-justify-between tw-border-0
            tw-border-b tw-border-solid tw-border-border-grey tw-pb-4
            ${i === 0 ? 'tw-mt-0' : 'tw-mt-4'}`}
        >
          <div className="tw-flex-1">
            <Skeleton className="tw-mb-0.5 tw-h-5 tw-w-3/4" />
            <Skeleton className="tw-mb-0 tw-h-4 tw-w-1/2" />
          </div>
          <div className="tw-flex tw-items-center tw-gap-2">
            <Skeleton className="tw-h-5 tw-w-16" />
          </div>
        </div>
      ))}
    </div>
  );
};
